import { createTheme } from '@mui/material/styles';

export default createTheme({
  breakpoints:{
    values:{
            sm: 0,
            md: 569,
            lg: 1024,
        },
  },
  overrides: {
    MuiButton: {
      text: {       
          padding: '0.75rem 1.5rem',
      },
      root: {        
           textTransform: 'none',
           letterSpacing: 'var(--mdc-typography-button-letter-spacing,0)',
           fontWeight: 'var(--mdc-typography-button-font-weight,700)',
           fontStyle: 'var(--mdc-typography-button-font-style,normal)',
           fontFamily: 'var(--mdc-typography-button-font-family,var(--mdc-typography-font-family, Raleway, sans-serif))',
           borderRadius: '0.125rem'
       }
    },
    
  }
  
});
